



































import { Component, Prop, Vue } from 'vue-property-decorator';
import BpcDatePicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import SearchAndOrder from '@core/interfaces/bpc-search-and-order';

@Component({
  name: 'bpc-resync-modal',
  components: {
    BpcDatePicker,
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class ResyncFinddocProductModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'resync-modal' }) readonly modalId: string;
  @Prop({ type: String, default: 'entry' }) readonly entity: string;
  @Prop({ type: Array, default: [] }) readonly ids: number[] | string[];

  @Prop({ type: Number, default: 0 }) readonly totalEntities: number;
  @Prop({ type: Boolean, default: false }) readonly checkedAll: boolean;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly filterModel;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly searchAndOrder: SearchAndOrder;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly selectedEntities: string[];

  // Data
  public processAll: boolean = false;
  public isProcessing: boolean = false;

  get modalTitle(): string {
    return this.$t('access_control.finddoc_sync_modal.title').toString();
  }

  get modalBody(): string {
    if (this.entity === 'activity-session') {
      return this.$t('global.access_control.finddoc_session_sync_modal.body').toString();
    } else {
      return this.$t('access_control.finddoc_sync_modal.body').toString();
    }
  }
  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  // Lifecycle
  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  // Methods
  closeModal() {
    this.$emit('close-modal');
    this.$bvModal.hide(this.modalId);
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  process() {
    this.isProcessing = true;
    const path = `${this.$bpcApiRouteHelper.getEntityPath(this.entity)}/resync`;
    this.$bpcApi
      .post(path, {
        selectedItems: this.selectedEntities,
        filters: this.filterModel,
        searchAndOrder: this.searchAndOrder,
        processAll: this.processAll,
      })
      .subscribe(
        result => {
          this.isProcessing = false;
          this.$emit('processing-resync-start');
        },
        error => {
          this.isProcessing = false;
        },
      );
  }
}
